export default __webpack_public_path__ + "static/the_periodic_table-65338e6103a8b17b04bc011e54a7ffac.png";